import React from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { DialogProps } from '@mui/material/Dialog';
import * as serverProxy from 'src/routes/UserAccount/UserTeamManagement/serverProxy';
import { useAppSelector, useSnackbar } from 'src/utils/Hooks';
import _get from 'lodash/get';
import { settingsErrorMessage } from '../../utils';
import TeamUserOptionPopup from '../TeamUserOptionPopup';
import { isV2Enabled } from 'src/utils/authVersion';

type RemoveUserPopupProps = Omit<DialogProps, 'children' | 'sx'> & {
  user: {
    email: string;
  };
  refetchData: () => Promise<void>;
};

/**
 * Popup for removing a user from a team
 */
export default function RemoveUserPopup({ user, refetchData, ...rest }: RemoveUserPopupProps) {
  const { showSnackbar } = useSnackbar();
  const currentEmail = useAppSelector((state) => state.user.config.profile.email);

  const deleteUser = async () => {
    try {
      const isV2 = isV2Enabled();
      if (isV2) {
        await serverProxy.RemoveMembershipFromDivision(user.email);
      } else {
        await serverProxy.DisableUserFromDivision(user.email, currentEmail);
      }
      await refetchData();

      showSnackbar({
        message: `You've removed ${user.email} from your division.`,
        type: 'success'
      });
    } catch (error) {
      console.error(error);
      showSnackbar({
        message: _get(error, 'response.data', settingsErrorMessage),
        type: 'error'
      });
    }
  };

  return (
    <TeamUserOptionPopup modalTitle="Remove User From Team" onConfirm={() => deleteUser()} {...rest}>
      <Text variant="subtitle2" inline>
        {user.email}
      </Text>{' '}
      will no longer be able to access this account. All segments created by this user will be permanently deleted.
    </TeamUserOptionPopup>
  );
}
